import MarkerClusterer from '@googlemaps/markerclustererplus';

class mapHandler {

    constructor(mapContainer) {
        this.mapContainer = mapContainer;
        this.ourMap;
        this.markers = [];
    }

    initMap() {
        console.log('init map');
        if(this.mapContainer != null) {

            const myCenter = { lat: 51.5074, lng: 0.1278 };
             var map = new google.maps.Map(document.getElementById('centres-map'), {
                zoom: 6,
                center: myCenter
            });
            this.ourMap = map;
        }
    }
    getMap() {
        return this.ourMap
    }
    addMarker(marker) {
        this.markers.push(marker);
    }
    drawMarkers(locations, map) {

        //TODO map zooming when click on marker
        console.log('draw');
        var marker, i;
        for (i = 0; i < locations.length; i++) {
            let lat = Number(locations[i].lat);
            let lng = Number(locations[i].lng);
            let center = { lat, lng };
            let url = locations[i].url;
            marker = new google.maps.Marker({
                position: center,
                map: map,
                url:url,
                lat:lat,
                lng:lng
            });
            this.addMarker(marker);
            //TODO - make universal
            google.maps.event.addListener(marker, 'click', function() {
                let _this = this;
                [...document.querySelectorAll('.b-centre-title')].forEach((center) => {
                    let centerLat = center.getAttribute('data-centre-latitude');
                    let centerLng = center.getAttribute('data-centre-longitude');
                    if(centerLat==_this.lat && centerLng == _this.lng) {
                        center.closest('.b-centre').scrollIntoView({ block: 'end',  behavior: 'smooth' });
                        [...document.querySelectorAll('.b-centre')].forEach((card) => {
                            if(card.classList.contains('is-active')) {
                                card.classList.remove('is-active');
                            }
                        })
                        center.closest('.b-centre').classList.add('is-active');
                    }
                })
            });
        }
    }
    setMapOnAll(map) {
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(map);
        }
    }
    hideMarkers() {
        this.setMapOnAll(null);
    }

}
export default mapHandler;
